module.exports = __webpack_public_path__ + "static/wag-tag-logo-266bea1442be3a222d72625c123a1a93.svg";